import React, { useEffect, useRef, useState } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import {
  DELTE_USER_PRODUCTS,
  FETCH_FOLLOW_ENTITIES,
  FETCH_PRODUCTS,
  FETCH_MANUFACTURER_PRODUCTS,
  FETCH_PRODUCTS_FAVOURITE_IMAGES,
  FETCH_PRODUCTS_POSTS_PICTURES,
  FETCH_PRODUCTS_POSTS_PICTURES_FOR_WEB,
  FETCH_TRADE_PRODUCTS,
  FETCH_TRADE_PRODUCTS_FOR_WEB,
  FETCH_USER_PRODUCTS,
  GET_PRODUCT_DETAILS_FOR_WEB,
  GET_PRODUCT_MEMBERS,
  SAVE_FOLLOW_ENTITIES,
  SAVE_POST_PICTURE,
  SAVE_POSTS,
  SAVE_USERS_EXPERIENCES_PRODUCTS
} from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import { useSelector } from "react-redux";
import {
  Alert,
  AppBar,
  Avatar,
  Box,
  Button,
  Card,
  CardHeader,
  CardMedia,
  Grid,
  IconButton,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import PlaceholderImg from "../../assets/images/placeholder_img.jpg";
import PictureViewer from "../common/PictureViewer";
import { BIBlue, BIRed, loadBitMovinPlayerScript } from "../../assets/helpers";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import VerifiedIcon from "@mui/icons-material/Verified";
import Loader from "../../common/Loader";
import ProductAboutSection from "./ProductAboutSection";
import ProductCompanySection from "./ProductCompanySection";
import { Getrequestcall } from "../../request/Getrequest";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import ProductReviewSection from "./ProductReviewSection";
import ProductPhotosSection from "./ProductPhotosSection";
import DeleteConfirmation from "../common/DeleteConfirmation";
import CheckIcon from "@mui/icons-material/Check";
import ProductPostsSection from "./ProductPostsSection";
import ProductProjectSection from "./ProductProjectSection";
import SendInChatModal from "../common/SendInChatModal";
import NoSuchPage from "../common/NoSuchPage";
import { SignInCard } from "../common/SignInCard";
import { setCommunityPostIds, setShowReport } from "../../redux/actions/actions";
import { useDispatch } from "react-redux";
import MemberList from "../common/MemberList";
import { English } from "../../constant/EnglishFallback";
import Pages from "../../constant/ReportModel";
import InfoIcon from "@mui/icons-material/Info";
import ProductSiteSection from "./ProductSiteSection";
import ProductDocumentSection from "./ProductDocumentSection";

const ProductProfile = () => {
  let scrollTargetId = "scrollablediv_prodcut";
  let { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loginData, multiLanguageData, open } = useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;
  const fileInputRef = useRef(null);
  const LanguageData = multiLanguageData?.Products || {};

  const {
    TEXT_SITES = English.Companies.TEXT_SITES,
  } = multiLanguageData?.Companies || {};

  const {
    TEXT_PRODUCTS = English.Products.TEXT_PRODUCTS,
    BUTTON_REMOVE_FROM_MY_PRODUCTS = English.Products.BUTTON_REMOVE_FROM_MY_PRODUCTS,
    BUTTON_ADD_PRODUCT_PICTURE = English.Products.BUTTON_ADD_PRODUCT_PICTURE,
    BUTTON_SEND_IN_CHAT = English.Products.BUTTON_SEND_IN_CHAT,
    BUTTON_SHARE = English.Products.BUTTON_SHARE,
    BUTTON_REPORT = English.Products.BUTTON_REPORT,
    TEXT_FOLLOW = English.Products.TEXT_FOLLOW,
    TEXT_FOLLOWING = English.Products.TEXT_FOLLOWING,
    BUTTON_I_WORKED_WITH_THIS = English.Products.BUTTON_I_WORKED_WITH_THIS,
    BUTTON_POSTS = English.Products.BUTTON_POSTS,
    BUTTON_PHOTOS = English.Products.BUTTON_PHOTOS,
    BUTTON_REVIEWS = English.Products.BUTTON_REVIEWS,
    BUTTON_PROJECTS = English.Products.BUTTON_PROJECTS,
    BUTTON_COMPANIES = English.Products.BUTTON_COMPANIES,
    TEXT_DELETE_MODAL_DESC1 = English.Products.TEXT_DELETE_MODAL_DESC1,
    TEXT_DELETE_MODAL_DESC2 = English.Products.TEXT_DELETE_MODAL_DESC2,
    BUTTON_MODAL_DELETE_REMOVE = English.Products.BUTTON_MODAL_DELETE_REMOVE,
    BUTTON_MODAL_DELETE_YES = English.Products.BUTTON_MODAL_DELETE_YES,
    TEXT_NO_PRODUCT_VISIBLE = English.Products.TEXT_NO_PRODUCT_VISIBLE,
    BUTTON_ABOUT = English.Products.BUTTON_ABOUT,
    TEXT_TECHNICAL_INFO = English.Products.TEXT_TECHNICAL_INFO
  } = LanguageData || {};

  const isAndroid = /Android/i.test(navigator.userAgent);
  const isIphone = /iPhone/i.test(navigator.userAgent);
  const isIpad = /iPad/i.test(navigator.userAgent);

  const [productData, setProductData] = useState({
    productDetails: null,
    tradeList: [],
    pictureList: [],
    memberList: [],
    followDetails: null
  });

  // Different tab configurations for verified/unverified
  const verifiedTabs = [
    { id: "1", label: BUTTON_ABOUT },
    { id: "2", label: BUTTON_POSTS },
    { id: "3", label: BUTTON_PHOTOS },
    { id: "4", label: BUTTON_REVIEWS },
    { id: "5", label: BUTTON_PROJECTS },
    { id: "6", label: TEXT_TECHNICAL_INFO },
    { id: "7", label: TEXT_SITES },
    { id: "8", label: BUTTON_COMPANIES },
  ];

  const unverifiedTabs = [
    { name: "posts", value: BUTTON_POSTS },
    { name: "photos", value: BUTTON_PHOTOS },
    { name: "reviews", value: BUTTON_REVIEWS },
    { name: "projects", value: BUTTON_PROJECTS },
    { name: "documents", value: TEXT_TECHNICAL_INFO },
    { name: "companies", value: BUTTON_COMPANIES },
    { name: "sites", value: TEXT_SITES },
  ];

  const [activeTab, setActiveTab] = useState("1"); // For verified products
  const [unverifiedActiveTab, setUnverifiedActiveTab] = useState("posts"); // For unverified
  const [showLoader, setShowLoader] = useState(true);
  const [showImagePreview, setShowImagePreview] = useState(false);
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);
  const [imageDataLoading, setImageDataLoading] = useState(true);
  const [isAddedToProfile, setIsAddedToProfile] = useState(false);
  const [showConformationModal, setShowConformationModal] = useState(null);
  const [showFollowLoader, setShowFollowLoader] = useState(false);
  const [showAddToProfileLoader, setShowAddToProfileLoader] = useState(false);
  const [showMemberList, setShowMemberList] = useState(false);
  const [showMemberBtnLoader, setShowMemberBtnLoader] = useState(false);
  const [showSendInChatModal, setShowSendInChatModal] = useState(false);
  const [noSuchData, setNoSuchData] = useState(false);

  const { pathname } = useLocation();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const isVerified = productData?.productDetails?.verified;

  let menuOptions = [
    {
      name: "Remove from My Products",
      value: BUTTON_REMOVE_FROM_MY_PRODUCTS
    },
    {
      name: "Add Product Picture",
      value: BUTTON_ADD_PRODUCT_PICTURE
    },
    {
      name: "Send in Chat",
      value: BUTTON_SEND_IN_CHAT
    },
    {
      name: "Share",
      value: BUTTON_SHARE
    },
    {
      name: "Report",
      value: BUTTON_REPORT
    }
  ];

  useEffect(() => {
    if (pathname.includes("proxySite")) {
      getProxyPageData();
    } else if (id) {
      loadBitMovinPlayerScript();
      getData();
    }
  }, [id]);

  // Proxy sites start
  const getProxyPageData = async () => {
    setShowLoader(true);
    try {
      const [productDetails, tradeList, pictureList] = await Promise.all([
        fetchProductDetailsForWeb().catch((e) => null),
        getProductTradeListForWeb().catch((e) => []),
        fetchPicturesForWeb().catch((e) => [])
      ]);
      setProductData({
        productDetails,
        tradeList,
        pictureList
      });
      openInPhone();
    } catch (error) {
      console.log("getProxyPageData-> Error While Getting Product Page All Data: ", error);
    } finally {
      setShowLoader(false);
    }
  };

  function openInPhone() {
    if (isAndroid) {
      const androidUrl = `intent://?screenName=${"ProductInfo"}&id=${id}#Intent;scheme=mybuilderid;package=com.mybuilderid;end`;
      window.location.replace(androidUrl);
    } else if (isIphone || isIpad) {
      const iPhoneUrl = `mybuilderid://?screenName=${"ProductInfo"}&id=${id}`;
      window.location.replace(iPhoneUrl);
    }
  }

  const fetchProductDetailsForWeb = async () => {
    try {
      const res = await Getrequestcall(`${GET_PRODUCT_DETAILS_FOR_WEB}/${id}`, undefined);
      let resData = res?.data?.data?.[0] ?? null;
      if (resData?.manufacturerName?.trim() !== "") {
        setUnverifiedActiveTab("posts");
      } else {
        setUnverifiedActiveTab("photos");
      }
      return resData;
    } catch (error) {
      console.log("fetchProductDetailsForWeb-> Error While fetching Product Detail: ", error);
    }
  };

  const getProductTradeListForWeb = async () => {
    try {
      let obj = {
        SearchList: [{ ProductId: id }]
      };
      const res = await Postrequestcall(FETCH_TRADE_PRODUCTS_FOR_WEB, obj, undefined);
      let resData = res?.data?.data ?? [];
      return resData;
    } catch (error) {
      console.log("getProductTradeListForWeb-> Error While Fetching Trade Product: ", error);
    }
  };

  const fetchPicturesForWeb = async () => {
    try {
      const postObj = {
        SearchList: [{ appRecordId: id }],
        SortList: [{ FieldName: "Id", Direction: "DESC" }]
      };
      const productPostPicturesRes = await Postrequestcall(
        FETCH_PRODUCTS_POSTS_PICTURES_FOR_WEB,
        postObj,
        undefined
      );
      let productPostPicturesData = productPostPicturesRes?.data?.data ?? [];
      return productPostPicturesData;
    } catch (error) {
      console.error("fetchPicturesForWeb-> Error When Fetching Product Post Picture: ", error);
    }
  };

  // Proxy sites end
  const getData = async () => {
    setShowLoader(true);
    try {
      const [productDetails, tradeList, pictureList, memberList, followDetails, isAddedToProfile] =
        await Promise.all([
          fetchProductDetails().catch((e) => null),
          getProductTradeList().catch((e) => []),
          fetchPictures().catch((e) => []),
          fetchProductMembers().catch((e) => []),
          fetchFollowsEntity().catch((e) => []),
          fetchUserProducts().catch((e) => [])
        ]);
      setProductData({
        productDetails,
        tradeList,
        pictureList,
        memberList,
        followDetails
      });
      setIsAddedToProfile(isAddedToProfile ?? false);
    } catch (error) {
      console.log("getData-> Error While Getting All Data Of Product: ", error);
    } finally {
      setShowLoader(false);
    }
  };

  const fetchProductDetails = async () => {
    try {
      const obj = {
        SearchList: [{ id }]
      };
      // const res = await Postrequestcall(FETCH_PRODUCTS, obj, loginData?.accessToken);
      const res = await Postrequestcall(FETCH_MANUFACTURER_PRODUCTS, obj, loginData?.accessToken);
      let resData = res?.data?.data?.[0] ?? null;
      setNoSuchData(resData ? false : true);
      if (resData?.manufacturerName?.trim() !== "") {
        setUnverifiedActiveTab("posts");
      } else {
        setUnverifiedActiveTab("photos");
      }
      return resData;
    } catch (error) {
      console.log("fetchProductDetails-> Error While Fetching Product Detail: ", error);
    }
  };

  const fetchProductMembers = async () => {
    try {
      const res = await Getrequestcall(
        `${GET_PRODUCT_MEMBERS}/${currentUserId}/${id}`,
        loginData?.accessToken
      );
      let resData = res?.data?.data ?? [];
      return resData;
    } catch (error) {
      console.log("fetchProductMembers-> Error While Fetching Product Member:", error);
    }
  };

  const getProductTradeList = async () => {
    try {
      let obj = {
        PageNr: 1,
        NrOfRecPerPage: 0,
        FullSearch: "",
        UserId: Number(currentUserId),
        IncludeRecordNr: true,
        TypeOfObjectReturned: "",
        SearchList: [{ ProductId: id }]
      };
      const res = await Postrequestcall(FETCH_TRADE_PRODUCTS, obj, loginData?.accessToken);
      let resData = res?.data?.data ?? [];
      return resData;
    } catch (error) {
      console.log("getProductTradeList-> Error While Fetching Trade Product: ", error);
    }
  };

  const fetchPictures = async () => {
    try {
      const postObj = {
        PageNr: 1,
        NrOfRecPerPage: 100,
        FullSearch: "",
        UserId: currentUserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [{ appRecordId: id }],
        SortList: [{ FieldName: "Id", Direction: "DESC" }]
      };
      const productPostPicturesRes = await Postrequestcall(
        FETCH_PRODUCTS_POSTS_PICTURES,
        postObj,
        loginData?.accessToken
      );
      let productPostPicturesData = productPostPicturesRes?.data?.data ?? [];
      const productFavImagesRes = await Postrequestcall(
        FETCH_PRODUCTS_FAVOURITE_IMAGES,
        postObj,
        loginData?.accessToken
      );
      let productFavImagesData = productFavImagesRes?.data?.data ?? [];
      const favoritePictureIds = new Set(productFavImagesData?.map((img) => img.productPictureId));
      const productWithFavImages = productPostPicturesData?.map((fav) => ({
        ...fav,
        isFavorite: favoritePictureIds.has(fav.pictureId)
      }));
      setImageDataLoading(false);
      return productWithFavImages;
    } catch (error) {
      setImageDataLoading(false);
      console.error("fetchPictures-> Error While Fetching Product Picture: ", error);
    }
  };

  const fetchFollowsEntity = async () => {
    try {
      const obj = {
        SearchList: [
          {
            EntityId: Number(id),
            userId: currentUserId
          }
        ]
      };

      const res = await Postrequestcall(FETCH_FOLLOW_ENTITIES, obj, loginData?.accessToken);
      let resData = res?.data?.data?.[0] ?? null;
      return resData;
    } catch (error) {
      console.log("fetchFollowsEntity-> Error While Fetching Follow Entities: ", error);
    }
  };

  const fetchUserProducts = async () => {
    try {
      const obj = {
        SearchList: [
          {
            userId: currentUserId,
            productId: id
          }
        ]
      };
      const res = await Postrequestcall(FETCH_USER_PRODUCTS, obj, loginData?.accessToken);
      let resData = res?.data?.data ?? null;
      return resData?.length > 0 ? true : false;
    } catch (error) {
      console.log("fetchUserProducts-> Error While Fetching user Product: ", error);
    }
  };

  let isSharing = false;
  const onShareClick = async () => {
    if (navigator.share) {
      if (isSharing) return;

      const shareData = {
        title: "Product Profile",
        url: window.location.href
      };

      isSharing = true;
      navigator
        .share(shareData)
        .catch((error) => console.error("isSharing-> Error When Trying To Share: ", error))
        .finally(() => {
          isSharing = false;
        });
    } else {
      try {
        try {
          await navigator.clipboard.writeText(window.location.href);
        } catch (err) {
          const textArea = document.createElement("textarea");
          textArea.value = window.location.href;
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();
          document.body.removeChild(textArea);
        }
        alert("Link copied to clipboard");
        isSharing = false;
      } catch (error) {
        console.log("isSharing-> Error When Trying To Share (fallback): ", error);
      }
    }
  };

  const onSendChatClick = () => {
    setShowSendInChatModal(true);
  };

  const onTradesSaveSuccessfully = async () => {
    try {
      const resData = await getProductTradeList();
      setProductData((prevData) => ({
        ...prevData,
        tradeList: resData ?? []
      }));
    } catch (error) {
      console.error("onTradesSaveSuccessfully-> Error When Getting Product Trade List: ", error);
    }
  };

  const onProductDetailsSaveSuccessfully = async () => {
    try {
      const resData = await fetchProductDetails();
      setProductData((prevData) => ({
        ...prevData,
        productDetails: resData ?? null
      }));
    } catch (error) {
      console.error(
        "onProductDetailsSaveSuccessfully-> Error While fetching Product Detail: ",
        error
      );
    }
  };

  const getUpdatedPhotos = async () => {
    setImageDataLoading(true);
    try {
      const resData = await fetchPictures();
      setProductData((prevData) => ({
        ...prevData,
        pictureList: resData ?? null
      }));
    } catch (error) {
      console.error("getUpdatedPhotos-> Error While Fetching Pictures: ", error);
    } finally {
      setImageDataLoading(false);
    }
  };

  const getSubTitle = (productInfo) => {
    const { manufacturerName } = productInfo || {};
    return manufacturerName;
  };
  // const getSubTitle = (productInfo) => {
  //   const { productType, manufacturerName } = productInfo || {};
  //   return productType || manufacturerName
  //     ? `${productType || ""}${productType && manufacturerName ? " | " : ""}${manufacturerName || ""}`
  //     : null;
  // };

  const getHeader = (productInfo) => {
    const { productType, name } = productInfo || {};
    return productType || name
      ? `${productType || ""}${productType && name ? " | " : ""}${name || ""}`
      : null;
  };

  const changeFollowStatus = async (isFollow) => {
    try {
      setShowFollowLoader(true);
      const obj = {
        UserId: Number(currentUserId),
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: productData?.followDetails?.id,
            EntityTypeId: 4,
            EntityId: Number(id),
            UserId: Number(currentUserId),
            IsFollowing: isFollow,
            ModifiedBy: Number(currentUserId)
          }
        ]
      };
      await Postrequestcall(SAVE_FOLLOW_ENTITIES, obj, loginData?.accessToken);
      // After follow products clear the community post redux 
      const grouped = {
        all: [],
        products: [],
        projects: [],
        trades: []
      };
      dispatch(setCommunityPostIds(grouped));
      const [memberList, followDetails] = await Promise.all([
        fetchProductMembers().catch((e) => []),
        fetchFollowsEntity().catch((e) => [])
      ]);
      setProductData((preValue) => ({
        ...preValue,
        memberList,
        followDetails
      }));
      setShowFollowLoader(false);
    } catch (error) {
      setShowFollowLoader(false);
      console.log("changeFollowStatus-> Error When Trying To Change Follow Status: ", error);
    }
  };

  const addProductToUserProfile = async () => {
    try {
      setShowAddToProfileLoader(true);
      const obj = {
        UserId: Number(currentUserId),
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: 0,
            UserId: Number(currentUserId),
            ProductId: Number(id),
            ModifiedBy: Number(currentUserId),
            UserExperienceId: 0,
            ProductIdList: Number(id)
          }
        ]
      };
      await Postrequestcall(SAVE_USERS_EXPERIENCES_PRODUCTS, obj, loginData?.accessToken);
      await changeFollowStatus(true);
      setIsAddedToProfile(true);
      setShowAddToProfileLoader(false);
    } catch (error) {
      setShowAddToProfileLoader(false);
      console.log(
        "addProductToUserProfile-> Error When Trying To add Product To User Profile: ",
        error
      );
    }
  };

  const removeProductFromUserProfile = async () => {
    try {
      setShowAddToProfileLoader(true);
      const obj = {
        UserId: Number(currentUserId),
        ReturnRecordError: true,
        DeleteList: [{ ProductId: id ?? 0, userId: currentUserId }]
      };
      await Postrequestcall(DELTE_USER_PRODUCTS, obj, loginData?.accessToken);
      setShowAddToProfileLoader(false);
      setIsAddedToProfile(false);
    } catch (error) {
      setShowAddToProfileLoader(false);
      console.log(
        "removeProductFromUserProfile-> Error While Removing Product From User Profile: ",
        error
      );
    }
  };

  const handleFileSelect = async (e) => {
    let files = e.target.files;
    if (files && files.length > 0) {
      let allFilesValid = true;
      for (let i = 0; i < files.length; i++) {
        if (!files[i].type.startsWith("image/")) {
          allFilesValid = false;
          break;
        }
      }
      if (allFilesValid) {
        setImageDataLoading(true);
        const obj = {
          UserId: Number(currentUserId),
          ReturnRecordId: true,
          ReturnRecordError: false,
          SaveList: [
            {
              Id: 0,
              FormatTypeId: 1,
              PostedByUserId: Number(currentUserId),
              AppId: 4,
              AppRecordId: id,
              Message: "<<<picture>>>",
              Reported: false,
              ModifiedBy: Number(currentUserId)
            }
          ]
        };
        try {
          const postRes = await Postrequestcall(SAVE_POSTS, obj, loginData?.accessToken);
          for (let i = 0; i < files.length; i++) {
            const formData = new FormData();
            formData.append("Id", 0);
            formData.append("PostId", postRes?.data?.data?.[0]?.objData?.id ?? 0);
            formData.append("ModifiedBy", currentUserId);
            formData.append("Pictures", files[i]);
            await Postrequestcall(SAVE_POST_PICTURE, formData, loginData?.accessToken, "formData");
          }
          await getUpdatedPhotos();
          if (isVerified) {
            setActiveTab("3"); // Photos tab for verified
          } else {
            setUnverifiedActiveTab("photos"); // Photos tab for unverified
          }
          setImageDataLoading(false);
        } catch (err) {
          setImageDataLoading(false);
          console.log("handleFileSelect-> Error While Saving Pictures: ", err);
        }
      } else {
        alert("Please select valid image files (JPEG, PNG, GIF, etc.).");
      }
    }
    e.target.value = null;
  };

  const handleOpenReportModal = () => {
    setMoreMenuAnchorEl(null);
    let reportObj = {
      showReport: true,
      recordId: productData?.productDetails?.id,
      name: Pages?.productProfile?.name,
      AppScreenId: Pages?.productProfile?.id
    };
    dispatch(setShowReport(reportObj));
  };

  if (noSuchData) {
    return (
      <Stack style={{ width: "100%", minHeight: "200px", marginTop: "20px" }}>
        <NoSuchPage />
      </Stack>
    );
  }

  // Render verified product layout
  const renderVerifiedLayout = () => (
    <Stack p={2}>
      <Card className="main-content-card" sx={{ overflow: "visible" }}>
        <Box className="main-content-card-list" id={scrollTargetId} sx={{ overflow: "visible" }}>
          <Grid container spacing={1}>
            <Grid
              size={{ xs: 12, md: 12 }}
              sx={{ height: "100%", boxShadow: "none", overflow: "visible" }}>
              <Card sx={{ height: "100%", boxShadow: "none", overflow: "visible" }}>
                <CardMedia
                  component="img"
                  height="300"
                  image={productData?.pictureList?.[0]?.pictureUrl ?? PlaceholderImg}
                  alt="Product Image"
                  onClick={() => setShowImagePreview(true)}
                />
                <Box p={2} pb={1} pt={1.5}>
                  <Grid container>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <ListItemText
                        primary={
                          <Stack sx={{ flexDirection: "row", gap: 1 }}>
                            {productData?.productDetails?.name}{" "}
                            {productData?.productDetails?.verified && (
                              <VerifiedIcon sx={{ color: BIBlue }} />
                            )}
                          </Stack>
                        }
                        secondary={getSubTitle(productData?.productDetails)}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <Stack
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="center"
                        spacing={1}>
                        <Button
                          loading={showFollowLoader}
                          variant="outlined"
                          sx={{
                            color: productData?.productDetails?.accentColor || BIBlue,
                            borderColor: productData?.productDetails?.accentColor || BIBlue
                          }}
                          onClick={() => {
                            productData?.followDetails?.isFollowing
                              ? setShowConformationModal("follow")
                              : changeFollowStatus(true);
                          }}>
                          {productData?.followDetails?.isFollowing ? TEXT_FOLLOWING : TEXT_FOLLOW}
                        </Button>

                        <Button
                          startIcon={isAddedToProfile && <CheckIcon fontSize="medium" />}
                          loading={showAddToProfileLoader}
                          variant={isAddedToProfile ? "outlined" : "text"}
                          sx={{
                            color: productData?.productDetails?.accentColor || BIBlue,
                            borderColor: productData?.productDetails?.accentColor || BIBlue
                          }}
                          onClick={() => {
                            isAddedToProfile
                              ? setShowConformationModal("worked")
                              : addProductToUserProfile();
                          }}>
                          {!isAddedToProfile && BUTTON_I_WORKED_WITH_THIS}
                        </Button>

                        <IconButton
                          aria-label="settings"
                          onClick={(event) => setMoreMenuAnchorEl(event.currentTarget)}>
                          <MoreVertIcon />
                        </IconButton>
                      </Stack>
                    </Grid>
                    {productData?.productDetails?.manufacturerName === "" && (
                      <Grid size={12} pb={1}>
                        <Alert icon={<InfoIcon />} severity="error">
                          {TEXT_NO_PRODUCT_VISIBLE}
                        </Alert>
                      </Grid>
                    )}
                  </Grid>

                  {productData?.memberList?.length > 0 && (
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      gap={1}>
                      <Stack
                        style={{ width: "100%", scrollbarWidth: "none", overflow: "auto" }}
                        direction="row"
                        gap={1}>
                        {productData?.memberList?.map((member, index) => (
                          <Avatar
                            key={index}
                            src={member.pictureUrl}
                            style={{ cursor: "pointer" }}
                            onClick={() => setShowMemberList(true)}
                          />
                        ))}
                      </Stack>
                      <Stack>
                        <IconButton onClick={() => setShowMemberList(true)}>
                          <KeyboardArrowRightIcon />
                        </IconButton>
                      </Stack>
                    </Stack>
                  )}
                </Box>
                <Box sx={{ width: "100%", typography: "body1" }}>
                  {pathname.includes("proxySite") &&
                    (activeTab === "2" ||
                      activeTab === "3" ||
                      activeTab === "4" ||
                      activeTab === "5" ||
                      activeTab === "6" ||
                      activeTab === "7") ? (
                    <SignInCard />
                  ) : (
                    <TabContext
                      value={activeTab}
                      variant="scrollable"
                      scrollButtons={false}
                      allowScrollButtonsMobile>
                      <AppBar
                        position="sticky"
                        sx={{
                          top: 0,
                          zIndex: 1100,
                          backgroundColor: "white",
                          boxShadow: "none",
                          borderBottom: 1,
                          borderColor: "divider",
                          marginBottom: "10px"
                        }}>
                        <TabList
                          onChange={(event, newValue) => setActiveTab(newValue)}
                          sx={{
                            "& .MuiTabs-indicator": {
                              backgroundColor: productData?.productDetails?.accentColor || BIBlue
                            },
                            "& .Mui-selected": {
                              color: productData?.productDetails?.accentColor
                            },
                            "& button.MuiButtonBase-root": {
                              color: productData?.productDetails?.accentColor
                            }
                          }}
                          aria-label="product tabs">
                          {verifiedTabs?.map((tab) => {
                            // Skip posts tab if manufacturer name is empty
                            if (
                              productData?.productDetails?.manufacturerName === "" &&
                              tab.id === "2"
                            ) {
                              return null;
                            }
                            return <Tab key={tab.id} label={tab.label} value={tab.id} />;
                          })}
                        </TabList>
                      </AppBar>

                      <TabPanel sx={{ padding: 0, mt: 1 }} value="1">
                        <ProductAboutSection
                          productDetails={productData?.productDetails}
                          tradeList={productData?.tradeList}
                          onTradesSaveSuccessfully={onTradesSaveSuccessfully}
                          onProductDetailsSaveSuccessfully={onProductDetailsSaveSuccessfully}
                          isVerified={true}
                          type={productData?.productDetails?.productType}
                          color={productData?.productDetails?.accentColor}
                        />
                      </TabPanel>

                      <TabPanel sx={{ padding: 0, mt: 1 }} value="2">
                        <ProductPostsSection id={id} scrollId={scrollTargetId} />
                      </TabPanel>

                      <TabPanel sx={{ padding: 0, mt: 1 }} value="3">
                        <ProductPhotosSection
                          id={id}
                          scrollId={scrollTargetId}
                          productDetails={productData?.productDetails}
                          photos={productData?.pictureList ?? []}
                          isLoading={imageDataLoading}
                          getUpdatedPhotos={getUpdatedPhotos}
                        />
                      </TabPanel>

                      <TabPanel sx={{ padding: 0, mt: 1 }} value="4">
                        <ProductReviewSection id={id} scrollId={scrollTargetId} />
                      </TabPanel>

                      <TabPanel sx={{ padding: 0, mt: 1 }} value="5">
                        <ProductProjectSection
                          id={id}
                          scrollId={scrollTargetId}
                          color={productData?.productDetails?.accentColor}
                        />
                      </TabPanel>

                      <TabPanel sx={{ padding: 0, mt: 1 }} value="6">
                        <ProductDocumentSection
                          id={id}
                          scrollId={scrollTargetId}
                          color={productData?.productDetails?.accentColor} />
                      </TabPanel>

                      <TabPanel sx={{ padding: 0, mt: 1 }} value="7">
                        <ProductSiteSection
                          id={id}
                          scrollId={scrollTargetId}
                          color={productData?.productDetails?.accentColor}
                        />
                      </TabPanel>

                      <TabPanel sx={{ padding: 0, mt: 1 }} value="8">
                        <ProductCompanySection
                          id={id}
                          scrollId={scrollTargetId}
                          color={productData?.productDetails?.accentColor}
                        />
                      </TabPanel>
                    </TabContext>
                  )}
                </Box>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </Card>
    </Stack>
  );

  // Render unverified product layout
  const renderUnverifiedLayout = () => (
    <Box className="main-content-Box" sx={{ p: isSmallScreen ? 2 : 3, pt: 2 }}>
      <Card className="main-content-card">
        <Box className="main-content-card-list" id={scrollTargetId}>
          <Grid container spacing={1.5}>
            <Grid size={{ xs: 12, md: 12 }}>
              <Card className="pagelist-content">
                <CardMedia
                  component="img"
                  height="300"
                  image={productData?.pictureList?.[0]?.pictureUrl ?? PlaceholderImg}
                  alt="Product Image"
                  onClick={() => setShowImagePreview(true)}
                />
                <Box p={2} pb={1} pt={1.5}>
                  <Grid container>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <ListItemText
                        primary={productData?.productDetails?.name}
                        secondary={getSubTitle(productData?.productDetails)}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <Stack
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="center"
                        spacing={1}>
                        <Button
                          loading={showFollowLoader}
                          variant="outlined"
                          onClick={() => {
                            productData?.followDetails?.isFollowing
                              ? setShowConformationModal("follow")
                              : changeFollowStatus(true);
                          }}>
                          {productData?.followDetails?.isFollowing ? TEXT_FOLLOWING : TEXT_FOLLOW}
                        </Button>

                        <Button
                          startIcon={isAddedToProfile && <CheckIcon fontSize="medium" />}
                          loading={showAddToProfileLoader}
                          variant={isAddedToProfile ? "outlined" : "text"}
                          onClick={() => {
                            isAddedToProfile
                              ? setShowConformationModal("worked")
                              : addProductToUserProfile();
                          }}>
                          {!isAddedToProfile && BUTTON_I_WORKED_WITH_THIS}
                        </Button>

                        <IconButton
                          aria-label="settings"
                          onClick={(event) => setMoreMenuAnchorEl(event.currentTarget)}>
                          <MoreVertIcon />
                        </IconButton>
                      </Stack>
                    </Grid>
                    {productData?.productDetails?.manufacturerName === "" && (
                      <Grid size={12} pb={1}>
                        <Alert icon={<InfoIcon />} severity="error">
                          {TEXT_NO_PRODUCT_VISIBLE}
                        </Alert>
                      </Grid>
                    )}
                  </Grid>

                  {productData?.memberList?.length > 0 && (
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      gap={1}>
                      <Stack
                        style={{ width: "100%", scrollbarWidth: "none", overflow: "auto" }}
                        direction="row"
                        gap={1}>
                        {productData?.memberList?.map((member, index) => (
                          <Avatar
                            key={index}
                            src={member.pictureUrl}
                            style={{ cursor: "pointer" }}
                            onClick={() => setShowMemberList(true)}
                          />
                        ))}
                      </Stack>
                      <Stack>
                        <IconButton onClick={() => setShowMemberList(true)}>
                          <KeyboardArrowRightIcon />
                        </IconButton>
                      </Stack>
                    </Stack>
                  )}
                </Box>
              </Card>
            </Grid>
          </Grid>

          <Box
            sx={{
              position: "sticky",
              top: 0,
              backgroundColor: "white",
              zIndex: 1200,
              borderBottom: 1,
              borderColor: "divider",
              marginBottom: "10px"
            }}>
            <Tabs
              variant="scrollable"
              scrollButtons={false}
              allowScrollButtonsMobile
              sx={{ minHeight: "30px" }}
              textColor="primary"
              indicatorColor="primary"
              value={unverifiedActiveTab}
              onChange={(event, newTab) => setUnverifiedActiveTab(newTab)}>
              {unverifiedTabs.map((tab, index) =>
                productData?.productDetails?.manufacturerName === "" &&
                  tab.name === "posts" ? null : (
                  <Tab key={index} value={tab.name} label={tab.value} />
                )
              )}
            </Tabs>
          </Box>
          <Grid container spacing={1.5}>
            <Grid size={{ xs: 12, md: 4 }}>
              <ProductAboutSection
                productDetails={productData?.productDetails}
                tradeList={productData?.tradeList}
                onTradesSaveSuccessfully={onTradesSaveSuccessfully}
                onProductDetailsSaveSuccessfully={onProductDetailsSaveSuccessfully}
                isVerified={false}
                type={productData?.productDetails?.productType}
              />
            </Grid>

            <Grid size={{ xs: 12, md: 8 }}>
              {pathname.includes("proxySite") &&
                (unverifiedActiveTab === "companies" ||
                  unverifiedActiveTab === "posts" ||
                  unverifiedActiveTab === "reviews" ||
                  unverifiedActiveTab === "projects" ||
                  unverifiedActiveTab === "documents" ||
                  unverifiedActiveTab === "photos" ||
                  unverifiedActiveTab === "sites") ? (
                <SignInCard />
              ) : (
                <>
                  {unverifiedActiveTab === "companies" && (
                    <ProductCompanySection id={id} scrollId={scrollTargetId} />
                  )}
                  {unverifiedActiveTab === "posts" && (
                    <ProductPostsSection id={id} scrollId={scrollTargetId} />
                  )}
                  {unverifiedActiveTab === "reviews" && (
                    <ProductReviewSection id={id} scrollId={scrollTargetId} />
                  )}
                  {unverifiedActiveTab === "projects" && (
                    <ProductProjectSection id={id} scrollId={scrollTargetId} />
                  )}
                  {unverifiedActiveTab === "documents" && (
                    <ProductDocumentSection id={id} scrollId={scrollTargetId} />
                  )}
                  {unverifiedActiveTab === "photos" && (
                    <ProductPhotosSection
                      id={id}
                      scrollId={scrollTargetId}
                      photos={productData?.pictureList ?? []}
                      isLoading={imageDataLoading}
                      getUpdatedPhotos={getUpdatedPhotos}
                    />
                  )}
                  {unverifiedActiveTab === "sites" && (
                    <ProductSiteSection id={id} scrollId={scrollTargetId} />
                  )}
                </>
              )}
            </Grid>
          </Grid>
        </Box>
      </Card>
    </Box>
  );

  return (
    <>
      {/* Common Header */}

      {/* Main Content */}
      {showLoader ? (
        <Card className="main-content-card">
          <Loader />
        </Card>
      ) : (
        <>
          {/* Render different layouts based on verification status */}
          {isVerified ? renderVerifiedLayout() : renderUnverifiedLayout()}
        </>
      )}

      {/* Common Modals and Components */}
      {showImagePreview && (
        <PictureViewer
          isOpen={showImagePreview}
          onClose={() => setShowImagePreview(false)}
          src={productData?.pictureList?.[0]?.pictureUrl ?? PlaceholderImg}
        />
      )}

      {showSendInChatModal && (
        <SendInChatModal
          isOpen={showSendInChatModal}
          onClose={() => setShowSendInChatModal(false)}
          fromTo="Product"
          title={productData?.productDetails?.name}
          imageUrl={productData?.pictureList?.[0]?.pictureUrl ?? PlaceholderImg}
        />
      )}

      {moreMenuAnchorEl && (
        <Menu
          anchorEl={moreMenuAnchorEl}
          open={Boolean(moreMenuAnchorEl)}
          onClose={() => setMoreMenuAnchorEl(null)}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}>
          {menuOptions.map((item, index) =>
            isAddedToProfile && item.name === "Remove from My Products" ? null : (
              <MenuItem
                onClick={() => {
                  if (item.name === "Share") {
                    onShareClick();
                  } else if (item.name === "Send in Chat") {
                    onSendChatClick();
                  } else if (item.name === "Report") {
                    handleOpenReportModal();
                  } else if (item.name === "Remove from My Products") {
                    setShowConformationModal("worked");
                  } else if (item.name === "Add Product Picture") {
                    fileInputRef.current.click();
                  } else {
                    setMoreMenuAnchorEl(null);
                  }
                  setMoreMenuAnchorEl(null);
                }}
                style={{ color: item.name === "Report" ? BIRed : "#083DB8" }}
                key={index}
                dense>
                {item.value}
              </MenuItem>
            )
          )}
        </Menu>
      )}

      {(showConformationModal === "follow" || showConformationModal === "worked") && (
        <DeleteConfirmation
          open={true}
          onClose={() => setShowConformationModal(null)}
          headerText={
            showConformationModal === "follow" ? TEXT_DELETE_MODAL_DESC1 : TEXT_DELETE_MODAL_DESC2
          }
          onBadgeClick={() => {
            setShowConformationModal(null);
            showConformationModal === "follow"
              ? changeFollowStatus(false)
              : removeProductFromUserProfile();
          }}
          actionBtnText={
            showConformationModal === "follow"
              ? BUTTON_MODAL_DELETE_YES
              : BUTTON_MODAL_DELETE_REMOVE
          }
        />
      )}

      {showMemberList && (
        <MemberList
          isOpen={showMemberList}
          onClose={() => setShowMemberList(false)}
          members={productData?.memberList ?? []}
          from="product-profile"
          setShowbtnLoader={setShowMemberBtnLoader}
          showBtnLoader={showMemberBtnLoader}
          setProductData={setProductData}
        />
      )}

      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileSelect}
        accept="image/*"
        multiple
      />
    </>
  );
};

export default ProductProfile;
